import { useEffect, useState } from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

const normalizeFilters = (filters: FieldValues = {}) =>
	Object.fromEntries(
		Object.entries(filters)
			.filter(([, value]) => value !== '' && value !== null && value !== undefined)
			.map(([key, value]) => [key, Array.isArray(value) ? [...value].sort() : value]),
	);

export const useClearFilter = <T extends FieldValues>(
	{ formState, handleSubmit, reset, getValues }: UseFormReturn<T>,
	onSubmit: (filters: T) => void,
) => {
	const [hasFilters, setHasFilters] = useState(false);

	const handleClear = () => {
		reset();
		handleSubmit(onSubmit)();
	};

	useEffect(() => {
		const currentValues = normalizeFilters(getValues());
		const defaultValues = normalizeFilters(formState.defaultValues);

		setHasFilters(JSON.stringify(currentValues) !== JSON.stringify(defaultValues));
	}, [formState.submitCount]);

	return { hasFilters, handleClear };
};
